<div class="flex flex-1 flex-col h-full">
	<app-document-matter-viewtor
		*ngIf="drawerData().showStateSelector"
		[id]="drawerData().documentId"
		class="h-full"
	>
	</app-document-matter-viewtor>

	<app-documents-matter-viewer
		class="h-full"
		[fileName]="drawerData().title ?? ''"
		*ngIf="!drawerData().showStateSelector"
		[id]="drawerData().documentId"
	>
	</app-documents-matter-viewer>
</div>
